import {createSlice} from '@reduxjs/toolkit'

const NAMESPACE = "hiddenModule"

// 来电信息
const slice = createSlice({
  name: NAMESPACE,
  initialState: {
    leftMenuShow: "yes",
    topMenuShow: "yes",
    mainHandContentShow: "yes",
    mainRoomContentShow: "yes",
    mainOnlineOrderContentShow: "yes",
    mainAppointOrderContentShow: "yes",
    mainIotDeviceContentShow: "yes",
    bottomAppointOrderSorShow: "yes",
    bottomShiftChangeShow: "yes",
    bottomServiceEndSortShow: "yes",
    bottomPositionChangeShow: "yes",
    rightDetailShow: "yes",
    rightAppointOrderShow: "yes",
    rightCallServeShow: "yes",
    rightBottomBookingShow: "yes",
    rightBottomBirthdayShow: "yes",
    rightAllShow: "yes",
    bottomAllShow: "yes",
  },
  reducers: {
    setLeftMenuShow(state, action) {
      state.leftMenuShow = action.payload
    },
    setTopMenuShow(state, action) {
      state.topMenuShow = action.payload
    },
    setMainHandContentShow(state, action) {
      state.mainHandContentShow = action.payload
    },
    setMainRoomContentShow(state, action) {
      state.mainRoomContentShow = action.payload
    },
    setMainOnlineOrderContentShow(state, action) {
      state.mainOnlineOrderContentShow = action.payload
    },
    setMainAppointOrderContentShow(state, action) {
      state.mainAppointOrderContentShow = action.payload
    },
    setMainIotDeviceContentShow(state, action) {
      state.mainIotDeviceContentShow = action.payload
    },
    setBottomAppointOrderSorShow(state, action) {
      state.bottomAppointOrderSorShow = action.payload
    },
    setBottomShiftChangeShow(state, action) {
      state.bottomShiftChangeShow = action.payload
    },
    setBottomServiceEndSortShow(state, action) {
      state.bottomServiceEndSortShow = action.payload
    },
    setBottomPositionChangeShow(state, action) {
      state.bottomPositionChangeShow = action.payload
    },
    setRightDetailShow(state, action) {
      state.rightDetailShow = action.payload
    },
    setRightAppointOrderShow(state, action) {
      state.rightAppointOrderShow = action.payload
    },
    setRightCallServeShow(state, action) {
      state.rightCallServeShow = action.payload
    },
    setRightBottomBookingShow(state, action) {
      state.rightBottomBookingShow = action.payload
    },
    setRightBottomBirthdayShow(state, action) {
      state.rightBottomBirthdayShow = action.payload
    },
    setRightAllShow(state, action) {
      state.rightAllShow = action.payload
    },
    setBottomAllShow(state, action) {
      state.bottomAllShow = action.payload
    },
  },
  extraReducers: {},
});

export const {
  setLeftMenuShow,
  setTopMenuShow,
  setMainHandContentShow,
  setMainRoomContentShow,
  setMainOnlineOrderContentShow,
  setMainAppointOrderContentShow,
  setMainIotDeviceContentShow,
  setBottomAppointOrderSorShow,
  setBottomShiftChangeShow,
  setBottomServiceEndSortShow,
  setBottomPositionChangeShow,
  setRightDetailShow,
  setRightAppointOrderShow,
  setRightCallServeShow,
  setRightBottomBookingShow,
  setRightBottomBirthdayShow,
  setRightAllShow,
  setBottomAllShow,
} = slice.actions

export const {reducer} = slice;
